import { useState } from "react";
import AddressDataTiles from "./components/AddressDataTile";
import AddressDataTable from "./components/AddressDataTable";

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

export default function Addresses() {
const [tileData, setTilesData] = useState<ColumnObjType>()
  const handleTiles = (data: ColumnObjType) =>{
    setTilesData(data)
  }

  return (
    <div className="flex flex-col gap-4 mt-4">
      <div className="flex-1">
        <AddressDataTiles data={tileData}/>
      </div>
      <div className="flex-1 tripTable">
        <AddressDataTable handleTile={handleTiles}/>
      </div>
    </div>

  );
}
